var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnDestroy, EventEmitter, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SessionService } from 'src/app/shared/service/session.service';
var SessionBrowserComponent = /** @class */ (function () {
    function SessionBrowserComponent(modalService, toastrService, sessionService) {
        this.modalService = modalService;
        this.toastrService = toastrService;
        this.sessionService = sessionService;
        this.afterBrowserRegister = new EventEmitter();
        this.cancelBrowserRegister = new EventEmitter();
        this.subscriptions = [];
    }
    SessionBrowserComponent.prototype.ngOnInit = function () { };
    SessionBrowserComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    SessionBrowserComponent.prototype.registerBrowser = function () {
        var _this = this;
        var param = __assign({}, this.loginForm, { browser: { name: this.newBrowserName } });
        this.newBrowserName = null;
        var sub = this.sessionService.registerBrowser(param).subscribe(function (res) {
            _this.afterBrowserRegister.emit({
                loginForm: _this.loginForm,
                response: res
            });
        }, function (error) {
            var message = error.error.errors[0] ||
                'ブラウザ登録に失敗しました. 再度お試しください';
            _this.toastrService.error(message);
        });
        this.subscriptions.push(sub);
    };
    SessionBrowserComponent.prototype.openModal = function (event, browser, content) {
        event.target.blur();
        this.selectedBrowser = null;
        // PointerEvent || MouseEvent (eventで取得できるものが違うため)
        if (event.pointerType == 'mouse' || event.detail == 1) {
            this.selectedBrowser = browser;
            this.modalService.open(content, { centered: true });
        }
    };
    SessionBrowserComponent.prototype.deleteBrowser = function () {
        var _this = this;
        var sub = this.sessionService
            .deleteBrowser(this.selectedBrowser.id, this.loginForm)
            .subscribe(function (res) {
            _this.browsers = _this.browsers.filter(function (b) { return b.id !== _this.selectedBrowser.id; });
            _this.modalService.dismissAll();
            _this.toastrService.success(_this.selectedBrowser.name + "\u306E\u60C5\u5831\u3092\u524A\u9664\u3057\u307E\u3057\u305F");
        }, function (error) {
            var message = error.error.errors[0] ||
                'ブラウザ情報の削除に失敗しました. 再度お試しください';
            _this.toastrService.error(message);
        });
        this.subscriptions.push(sub);
    };
    SessionBrowserComponent.prototype.cancel = function (event) {
        this.cancelBrowserRegister.emit(event);
    };
    return SessionBrowserComponent;
}());
export { SessionBrowserComponent };
